export default __webpack_public_path__ + "static/media/UBCVillageMedical.d8579610.png";